import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { CountryNamePipe } from '@shared/pipes/country-name.pipe';
import { SfCountrySelectorComponent } from './sf-country-selector/sf-country-selector.component';

@NgModule({
	declarations: [SfCountrySelectorComponent],
	exports: [SfCountrySelectorComponent],
	imports: [CommonModule, ReactiveFormsModule, MatAutocompleteModule, MatInputModule, TranslateModule, CountryNamePipe],
})
export class SfCountrySelectorModule {}
